import type { RefObject } from 'react'

import {
  type ScrollProximityAxis,
  useScrollProximityTrigger,
} from '../../hooks/useScrollProximityTrigger'

export type ScrollProximitySentinelProps = {
  rootRef: RefObject<Element | null>
  axis: ScrollProximityAxis
  distancePx?: number
  disabled?: boolean
  onTrigger: () => void
  className?: string
}

/**
 * 置于滚动内容末尾的哨兵节点；接近容器尾缘（竖向底部 / 横向右侧）时触发 onTrigger。
 */
export function ScrollProximitySentinel({
  rootRef,
  axis,
  distancePx,
  disabled,
  onTrigger,
  className = '',
}: ScrollProximitySentinelProps) {
  const sentinelRef = useScrollProximityTrigger({
    rootRef,
    axis,
    distancePx,
    disabled,
    onTrigger,
  })

  const size =
    axis === 'vertical'
      ? 'h-px w-full shrink-0 pointer-events-none'
      : 'h-full min-h-[64px] w-px shrink-0 self-stretch pointer-events-none'

  return <div ref={sentinelRef} className={[size, className].filter(Boolean).join(' ')} aria-hidden />
}
